'use strict'

import ReportMaterialsGroup from './ReportMaterialsGroup.js'

export default class ReportDemountingsGroup extends ReportMaterialsGroup {
  hasEqualComplexKeys (record1, record2) {
    if (record1.recId) {
      if (record1.recId !== record2.recId) {
        return false
      }
    } else {
      if (record1.toolName !== record2.toolName) {
        return false
      }
      if (record1.stockKey !== record2.stockKey) {
        return false
      }
      if (record1.serviceObjectKey !== record2.serviceObjectKey) {
        return false
      }
      if (record1.nomKey !== record2.nomKey) {
        return false
      }
      if (record1.sn !== record2.sn) {
        return false
      }
      if (record1.brigadeId !== record2.brigadeId) {
        return false
      }
    }
    return true
  }
}
